<script type="text/javascript">
const httpUrl = 'http://test.yf.hzcxy.cn/';
// const httpUrl = 'http://huzhou-admin.bmveky.top:82/';
export const tokenKey = "hztoken";
// 暴露出这些属性
export default {
  httpUrl,tokenKey
}
</script>
